import React from "react";
import classes from "./RelatedLinks.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import useEmblaOverflow from "../../../hooks/useEmblaOverflow";

const RelatedLinks = ({ countryData }: { countryData: any }) => {
  const linksData = countryData?.importantLinksSection ?? [];
  const isMobile = useIsMobile(768);
  const { emblaRef, hasOverflow, canScrollPrev, canScrollNext, scrollPrev, scrollNext } = useEmblaOverflow();

  const renderCards = () =>
    linksData?.importantLinks &&
    linksData?.importantLinks?.length > 0 &&
    linksData?.importantLinks?.map((link: any) => (
      <div className={classes["rl-slide"]} key={link.id}>
        <div className={classes["rl-card"]} onClick={() => window.open(link?.href ?? "", "_blank")}>
          <div className={classes["rl-thumbnail"]}>
            <CustomImage
              src={link.image?.url ?? "/icons/placeholder-image.svg"}
              alt={link.title}
              className={classes["rl-thumbnail-img"]}
              layout="fill"
              objectFit="fill"
            />
          </div>
          <p className={classes["rl-title"]}>{link?.label ?? ""}</p>
        </div>
      </div>
    ));

  const arrowLeft = (
    <button
      className={`${classes["rl-arrow"]}${canScrollPrev ? "" : ` ${classes["rl-arrow-disabled"]}`}`}
      onClick={scrollPrev}
      disabled={!canScrollPrev}
      aria-label="Previous"
    >
      <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="left-arrow" />
    </button>
  );

  const arrowRight = (
    <button
      className={`${classes["rl-arrow"]}${canScrollNext ? "" : ` ${classes["rl-arrow-disabled"]}`}`}
      onClick={scrollNext}
      disabled={!canScrollNext}
      aria-label="Next"
    >
      <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="right-arrow" />
    </button>
  );

  return (
    <section id="related-links" className={classes["rl-section"]}>
      <div className={classes["rl-container"]}>
        <h2 className={classes["rl-heading"]}>{linksData?.title ?? ""}</h2>
        {countryData?.importantLinksDescription && (
          <div className={classes["rl-subtext"]} dangerouslySetInnerHTML={{ __html: linksData?.description ?? "" }}></div>
        )}

        {isMobile ? (
          <div className={classes["rl-carousel-wrap"]}>
            <div className={classes["rl-viewport"]} ref={emblaRef}>
              <div className={classes["rl-slider"]}>{renderCards()}</div>
            </div>
            {hasOverflow && (
              <div className={classes["rl-arrows-below"]}>
                {arrowLeft}
                {arrowRight}
              </div>
            )}
          </div>
        ) : (
          <>
            <div style={linksData?.importantLinks?.length < 4 ? { justifyContent: "center" } : {}} className={classes["rl-carousel-wrap"]}>
              <div className={classes["rl-viewport"]} ref={emblaRef}>
                <div style={linksData?.importantLinks?.length < 4 ? { justifyContent: "center" } : {}} className={classes["rl-slider"]}>
                  {renderCards()}
                </div>
              </div>
            </div>
            {hasOverflow && (
              <div className={classes["rl-arrows-container"]}>
                {arrowLeft}
                {arrowRight}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default RelatedLinks;
